import {
  getPlatformTableListRowsTeamMockHandler,
  getPlatformTableListRowsTeamResponseMock,
} from '@cloudquery/api-platform';

import { processPaginatedListData } from '../utils';
import assetInventoryTableData from './data/assetInventoryTableData.json';

export const getCustomPlatformTableListRowsMockHandler = () => {
  return getPlatformTableListRowsTeamMockHandler((info) => {
    if (info.params.tableName === 'cloud_assets') {
      return processPaginatedListData(info.request.url, assetInventoryTableData);
    }

    return getPlatformTableListRowsTeamResponseMock();
  });
};
